module.exports = __webpack_public_path__ + "img/info6ss.21eb78a3.jpg";